var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgroundGraphics1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M392.435,767.303c-0.002-0.004-0.002-0.01-0.002-0.017 C392.434,767.293,392.434,767.299,392.435,767.303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M392.566,768.133c0.002,0,0.002,0,0.003,0c-0.05-0.236-0.089-0.471-0.119-0.703 C392.48,767.664,392.52,767.898,392.566,768.133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M393.425,770.539c-0.006-0.01-0.011-0.022-0.018-0.033 C393.414,770.518,393.419,770.529,393.425,770.539z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M393.343,770.379c-0.023-0.045-0.044-0.09-0.066-0.135 C393.299,770.291,393.32,770.334,393.343,770.379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M392.808,769.059c0.127,0.4,0.279,0.789,0.457,1.158c-0.181-0.377-0.33-0.766-0.454-1.158 C392.81,769.059,392.809,769.059,392.808,769.059z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "objects_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 426.896,
    y: 418.298,
    style: {
      fill: "none"
    },
    width: 334.106,
    height: 30.882
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.896,
    y: 455.219,
    style: {
      fill: "none"
    },
    width: 318.913,
    height: 50.138
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M659.807,52.675c-22.449,0.03-40.666,18.11-40.922,40.505 C641.334,93.15,659.55,75.07,659.807,52.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91C254"
    },
    d: "M659.807,138.675c-22.449,0.03-40.666,18.11-40.922,40.505 C641.334,179.15,659.55,161.07,659.807,138.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91C254"
    },
    d: "M702.809,179.389c-0.031-22.449-18.11-40.666-40.507-40.922 C662.332,160.915,680.412,179.132,702.809,179.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M618.885,95.257c0.03,22.449,18.11,40.666,40.506,40.922 C659.36,113.73,641.28,95.514,618.885,95.257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91C254"
    },
    d: "M746.226,138.675c-22.449,0.03-40.666,18.11-40.923,40.505 C727.752,179.15,745.969,161.07,746.226,138.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M789.227,179.389c-0.03-22.449-18.11-40.666-40.506-40.922 C748.751,160.915,766.83,179.132,789.227,179.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M748.305,135.971c22.449-0.03,40.666-18.11,40.922-40.506 C766.777,95.496,748.561,113.576,748.305,135.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M705.303,95.257c0.031,22.449,18.11,40.666,40.507,40.922 C745.779,113.73,727.699,95.514,705.303,95.257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M659.807,224.675c-22.449,0.03-40.666,18.11-40.922,40.505 C641.334,265.15,659.55,247.07,659.807,224.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M702.809,265.389c-0.031-22.449-18.11-40.666-40.507-40.922 C662.332,246.915,680.412,265.132,702.809,265.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91C254"
    },
    d: "M661.886,221.971c22.449-0.03,40.666-18.11,40.923-40.506 C680.359,181.496,662.143,199.576,661.886,221.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91C254"
    },
    d: "M618.885,181.257c0.03,22.449,18.11,40.666,40.506,40.922 C659.36,199.73,641.28,181.514,618.885,181.257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M789.227,265.389c-0.03-22.449-18.11-40.666-40.506-40.922 C748.751,246.915,766.83,265.132,789.227,265.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M748.305,221.971c22.449-0.03,40.666-18.11,40.922-40.506 C766.777,181.496,748.561,199.576,748.305,221.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91C254"
    },
    d: "M705.303,181.257c0.031,22.449,18.11,40.666,40.507,40.922 C745.779,199.73,727.699,181.514,705.303,181.257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91C254"
    },
    d: "M659.807,310.675c-22.449,0.03-40.666,18.11-40.922,40.505 C641.334,351.15,659.55,333.07,659.807,310.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M661.886,307.971c22.449-0.03,40.666-18.11,40.923-40.506 C680.359,267.496,662.143,285.576,661.886,307.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M618.885,267.257c0.03,22.449,18.11,40.666,40.506,40.922 C659.36,285.73,641.28,267.514,618.885,267.257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M748.305,307.971c22.449-0.03,40.666-18.11,40.922-40.506 C766.777,267.496,748.561,285.576,748.305,307.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M705.303,267.257c0.031,22.449,18.11,40.666,40.507,40.922 C745.779,285.73,727.699,267.514,705.303,267.257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M486.807,52.675c-22.449,0.03-40.666,18.11-40.922,40.505 C468.334,93.15,486.55,75.07,486.807,52.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M529.809,93.389c-0.031-22.449-18.11-40.666-40.507-40.922 C489.332,74.915,507.412,93.132,529.809,93.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M445.885,9.257c0.03,22.449,18.11,40.666,40.506,40.922C486.36,27.73,468.28,9.514,445.885,9.257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M573.226,52.675c-22.449,0.03-40.666,18.11-40.923,40.505 C554.752,93.15,572.969,75.07,573.226,52.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M616.227,93.389c-0.03-22.449-18.11-40.666-40.506-40.922 C575.751,74.915,593.83,93.132,616.227,93.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M486.807,138.675c-22.449,0.03-40.666,18.11-40.922,40.505 C468.334,179.15,486.55,161.07,486.807,138.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M529.809,179.389c-0.031-22.449-18.11-40.666-40.507-40.922 C489.332,160.915,507.412,179.132,529.809,179.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M488.886,135.971c22.449-0.03,40.666-18.11,40.923-40.506 C507.359,95.496,489.143,113.576,488.886,135.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M445.885,95.257c0.03,22.449,18.11,40.666,40.506,40.922 C486.36,113.73,468.28,95.514,445.885,95.257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M573.226,138.675c-22.449,0.03-40.666,18.11-40.923,40.505 C554.752,179.15,572.969,161.07,573.226,138.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M616.227,179.389c-0.03-22.449-18.11-40.666-40.506-40.922 C575.751,160.915,593.83,179.132,616.227,179.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M575.305,135.971c22.449-0.03,40.666-18.11,40.922-40.506 C593.777,95.496,575.561,113.576,575.305,135.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M532.303,95.257c0.031,22.449,18.11,40.666,40.507,40.922 C572.779,113.73,554.699,95.514,532.303,95.257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91C254"
    },
    d: "M486.807,224.675c-22.449,0.03-40.666,18.11-40.922,40.505 C468.334,265.15,486.55,247.07,486.807,224.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M488.886,221.971c22.449-0.03,40.666-18.11,40.923-40.506 C507.359,181.496,489.143,199.576,488.886,221.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M573.226,224.675c-22.449,0.03-40.666,18.11-40.923,40.505 C554.752,265.15,572.969,247.07,573.226,224.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M575.305,221.971c22.449-0.03,40.666-18.11,40.922-40.506 C593.777,181.496,575.561,199.576,575.305,221.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M532.303,181.257c0.031,22.449,18.11,40.666,40.507,40.922 C572.779,199.73,554.699,181.514,532.303,181.257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M486.807,310.675c-22.449,0.03-40.666,18.11-40.922,40.505 C468.334,351.15,486.55,333.07,486.807,310.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91C254"
    },
    d: "M488.886,307.971c22.449-0.03,40.666-18.11,40.923-40.506 C507.359,267.496,489.143,285.576,488.886,307.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91C254"
    },
    d: "M445.885,267.257c0.03,22.449,18.11,40.666,40.506,40.922 C486.36,285.73,468.28,267.514,445.885,267.257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91C254"
    },
    d: "M616.227,351.389c-0.03-22.449-18.11-40.666-40.506-40.922 C575.751,332.915,593.83,351.132,616.227,351.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M532.303,267.257c0.031,22.449,18.11,40.666,40.507,40.922 C572.779,285.73,554.699,267.514,532.303,267.257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M659.807,655.675c-22.449,0.03-40.666,18.11-40.922,40.505 C641.334,696.15,659.55,678.07,659.807,655.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M702.809,696.389c-0.031-22.449-18.11-40.666-40.507-40.922 C662.332,677.916,680.412,696.132,702.809,696.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M661.886,652.971c22.449-0.029,40.666-18.109,40.923-40.506 C680.359,612.496,662.143,630.576,661.886,652.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3AAA35"
    },
    d: "M618.885,612.258c0.03,22.449,18.11,40.666,40.506,40.922 C659.36,630.731,641.28,612.514,618.885,612.258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M746.226,655.675c-22.449,0.03-40.666,18.11-40.923,40.505 C727.752,696.15,745.969,678.07,746.226,655.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M789.227,696.389c-0.03-22.449-18.11-40.666-40.506-40.922 C748.751,677.916,766.83,696.132,789.227,696.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3AAA35"
    },
    d: "M748.305,652.971c22.449-0.029,40.666-18.109,40.922-40.506 C766.777,612.496,748.561,630.576,748.305,652.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3AAA35"
    },
    d: "M445.885,354.257c0.03,22.449,18.11,40.666,40.506,40.922 C486.36,372.73,468.28,354.514,445.885,354.257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M486.807,569.675c-22.449,0.03-40.666,18.11-40.922,40.505 C468.334,610.15,486.55,592.07,486.807,569.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3AAA35"
    },
    d: "M529.809,696.389c-0.031-22.449-18.11-40.666-40.507-40.922 C489.332,677.916,507.412,696.132,529.809,696.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M488.886,652.971c22.449-0.029,40.666-18.109,40.923-40.506 C507.359,612.496,489.143,630.576,488.886,652.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91C254"
    },
    d: "M616.227,696.389c-0.03-22.449-18.11-40.666-40.506-40.922 C575.751,677.916,593.83,696.132,616.227,696.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M532.303,612.258c0.031,22.449,18.11,40.666,40.507,40.922 C572.779,630.731,554.699,612.514,532.303,612.258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M313.807,52.675c-22.449,0.03-40.666,18.11-40.922,40.505 C295.334,93.15,313.55,75.07,313.807,52.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M315.886,49.971c22.449-0.03,40.666-18.11,40.923-40.506 C334.359,9.496,316.143,27.576,315.886,49.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M400.226,52.675c-22.449,0.03-40.666,18.11-40.923,40.505 C381.752,93.15,399.969,75.07,400.226,52.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M443.227,93.389c-0.03-22.449-18.11-40.666-40.506-40.922 C402.751,74.915,420.83,93.132,443.227,93.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M402.305,49.971c22.449-0.03,40.666-18.11,40.922-40.506 C420.777,9.496,402.561,27.576,402.305,49.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M359.303,9.257c0.031,22.449,18.11,40.666,40.507,40.922 C399.779,27.73,381.699,9.514,359.303,9.257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M313.807,138.675c-22.449,0.03-40.666,18.11-40.922,40.505 C295.334,179.15,313.55,161.07,313.807,138.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M315.886,135.971c22.449-0.03,40.666-18.11,40.923-40.506 C334.359,95.496,316.143,113.576,315.886,135.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M272.885,95.257c0.03,22.449,18.11,40.666,40.506,40.922 C313.36,113.73,295.28,95.514,272.885,95.257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M400.226,138.675c-22.449,0.03-40.666,18.11-40.923,40.505 C381.752,179.15,399.969,161.07,400.226,138.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91C254"
    },
    d: "M443.227,179.389c-0.03-22.449-18.11-40.666-40.506-40.922 C402.751,160.915,420.83,179.132,443.227,179.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91C254"
    },
    d: "M402.305,135.971c22.449-0.03,40.666-18.11,40.922-40.506 C420.777,95.496,402.561,113.576,402.305,135.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M359.303,95.257c0.031,22.449,18.11,40.666,40.507,40.922 C399.779,113.73,381.699,95.514,359.303,95.257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M313.807,224.675c-22.449,0.03-40.666,18.11-40.922,40.505 C295.334,265.15,313.55,247.07,313.807,224.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M315.886,221.971c22.449-0.03,40.666-18.11,40.923-40.506 C334.359,181.496,316.143,199.576,315.886,221.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M272.885,181.257c0.03,22.449,18.11,40.666,40.506,40.922 C313.36,199.73,295.28,181.514,272.885,181.257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M400.226,224.675c-22.449,0.03-40.666,18.11-40.923,40.505 C381.752,265.15,399.969,247.07,400.226,224.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91C254"
    },
    d: "M443.227,265.389c-0.03-22.449-18.11-40.666-40.506-40.922 C402.751,246.915,420.83,265.132,443.227,265.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M402.305,221.971c22.449-0.03,40.666-18.11,40.922-40.506 C420.777,181.496,402.561,199.576,402.305,221.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M359.303,181.257c0.031,22.449,18.11,40.666,40.507,40.922 C399.779,199.73,381.699,181.514,359.303,181.257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M313.807,310.675c-22.449,0.03-40.666,18.11-40.922,40.505 C295.334,351.15,313.55,333.07,313.807,310.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3AAA35"
    },
    d: "M356.809,351.389c-0.031-22.449-18.11-40.666-40.507-40.922 C316.332,332.915,334.412,351.132,356.809,351.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3AAA35"
    },
    d: "M315.886,307.971c22.449-0.03,40.666-18.11,40.923-40.506 C334.359,267.496,316.143,285.576,315.886,307.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M272.885,267.257c0.03,22.449,18.11,40.666,40.506,40.922 C313.36,285.73,295.28,267.514,272.885,267.257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M400.226,310.675c-22.449,0.03-40.666,18.11-40.923,40.505 C381.752,351.15,399.969,333.07,400.226,310.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M443.227,351.389c-0.03-22.449-18.11-40.666-40.506-40.922 C402.751,332.915,420.83,351.132,443.227,351.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91C254"
    },
    d: "M402.305,307.971c22.449-0.03,40.666-18.11,40.922-40.506 C420.777,267.496,402.561,285.576,402.305,307.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M140.807,52.675c-22.449,0.03-40.666,18.11-40.922,40.505 C122.334,93.15,140.55,75.07,140.807,52.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M183.809,93.389c-0.031-22.449-18.11-40.666-40.507-40.922 C143.332,74.915,161.412,93.132,183.809,93.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M270.227,93.389c-0.03-22.449-18.11-40.666-40.506-40.922 C229.751,74.915,247.83,93.132,270.227,93.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M183.809,179.389c-0.031-22.449-18.11-40.666-40.507-40.922 C143.332,160.915,161.412,179.132,183.809,179.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91C254"
    },
    d: "M227.226,138.675c-22.449,0.03-40.666,18.11-40.923,40.505 C208.752,179.15,226.969,161.07,227.226,138.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M270.227,179.389c-0.03-22.449-18.11-40.666-40.506-40.922 C229.751,160.915,247.83,179.132,270.227,179.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M229.305,135.971c22.449-0.03,40.666-18.11,40.922-40.506 C247.777,95.496,229.561,113.576,229.305,135.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91C254"
    },
    d: "M186.303,95.257c0.031,22.449,18.11,40.666,40.507,40.922 C226.779,113.73,208.699,95.514,186.303,95.257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M183.809,265.389c-0.031-22.449-18.11-40.666-40.507-40.922 C143.332,246.915,161.412,265.132,183.809,265.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M142.886,221.971c22.449-0.03,40.666-18.11,40.923-40.506 C161.359,181.496,143.143,199.576,142.886,221.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M227.226,224.675c-22.449,0.03-40.666,18.11-40.923,40.505 C208.752,265.15,226.969,247.07,227.226,224.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M270.227,265.389c-0.03-22.449-18.11-40.666-40.506-40.922 C229.751,246.915,247.83,265.132,270.227,265.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M140.807,310.675c-22.449,0.03-40.666,18.11-40.922,40.505 C122.334,351.15,140.55,333.07,140.807,310.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91C254"
    },
    d: "M183.809,351.389c-0.031-22.449-18.11-40.666-40.507-40.922 C143.332,332.915,161.412,351.132,183.809,351.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91C254"
    },
    d: "M142.886,307.971c22.449-0.03,40.666-18.11,40.923-40.506 C161.359,267.496,143.143,285.576,142.886,307.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M99.885,267.257c0.03,22.449,18.11,40.666,40.506,40.922 C140.36,285.73,122.28,267.514,99.885,267.257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91C254"
    },
    d: "M227.226,310.675c-22.449,0.03-40.666,18.11-40.923,40.505 C208.752,351.15,226.969,333.07,227.226,310.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91C254"
    },
    d: "M270.227,351.389c-0.03-22.449-18.11-40.666-40.506-40.922 C229.751,332.915,247.83,351.132,270.227,351.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91C254"
    },
    d: "M229.305,307.971c22.449-0.03,40.666-18.11,40.922-40.506 C247.777,267.496,229.561,285.576,229.305,307.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91C254"
    },
    d: "M186.303,267.257c0.031,22.449,18.11,40.666,40.507,40.922 C226.779,285.73,208.699,267.514,186.303,267.257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M313.807,397.675c-22.449,0.03-40.666,18.11-40.922,40.505 C295.334,438.15,313.55,420.07,313.807,397.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M315.886,394.971c22.449-0.03,40.666-18.11,40.923-40.506 C334.359,354.496,316.143,372.576,315.886,394.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M272.885,354.257c0.03,22.449,18.11,40.666,40.506,40.922 C313.36,372.73,295.28,354.514,272.885,354.257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M359.303,354.257c0.031,22.449,18.11,40.666,40.507,40.922 C399.779,372.73,381.699,354.514,359.303,354.257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91C254"
    },
    d: "M272.885,440.258c0.03,22.449,18.11,40.666,40.506,40.922 C313.36,458.73,295.28,440.514,272.885,440.258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M359.303,440.258c0.031,22.449,18.11,40.666,40.507,40.922 C399.779,458.73,381.699,440.514,359.303,440.258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M356.809,610.389c-0.031-22.449-18.11-40.666-40.507-40.922 C316.332,591.916,334.412,610.132,356.809,610.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M315.886,566.971c22.449-0.029,40.666-18.109,40.923-40.506 C334.359,526.496,316.143,544.576,315.886,566.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M487.02,567.179c-0.029-22.449-18.11-40.666-40.507-40.922 C446.546,548.706,464.626,566.922,487.02,567.179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M313.807,655.675c-22.449,0.03-40.666,18.11-40.922,40.505 C295.334,696.15,313.55,678.07,313.807,655.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3AAA35"
    },
    d: "M356.809,696.389c-0.031-22.449-18.11-40.666-40.507-40.922 C316.332,677.916,334.412,696.132,356.809,696.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M272.885,612.258c0.03,22.449,18.11,40.666,40.506,40.922 C313.36,630.731,295.28,612.514,272.885,612.258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3AAA35"
    },
    d: "M400.226,655.675c-22.449,0.03-40.666,18.11-40.923,40.505 C381.752,696.15,399.969,678.07,400.226,655.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M443.227,696.389c-0.03-22.449-18.11-40.666-40.506-40.922 C402.751,677.916,420.83,696.132,443.227,696.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M402.305,652.971c22.449-0.029,40.666-18.109,40.922-40.506 C420.777,612.496,402.561,630.576,402.305,652.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3AAA35"
    },
    d: "M140.807,397.675c-22.449,0.03-40.666,18.11-40.922,40.505 C122.334,438.15,140.55,420.07,140.807,397.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M183.809,438.389c-0.031-22.449-18.11-40.666-40.507-40.922 C143.332,419.916,161.412,438.132,183.809,438.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91C254"
    },
    d: "M142.886,394.971c22.449-0.03,40.666-18.11,40.923-40.506 C161.359,354.496,143.143,372.576,142.886,394.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M99.885,354.257c0.03,22.449,18.11,40.666,40.506,40.922 C140.36,372.73,122.28,354.514,99.885,354.257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M227.226,397.675c-22.449,0.03-40.666,18.11-40.923,40.505 C208.752,438.15,226.969,420.07,227.226,397.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M270.227,438.389c-0.03-22.449-18.11-40.666-40.506-40.922 C229.751,419.916,247.83,438.132,270.227,438.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91C254"
    },
    d: "M186.303,354.257c0.031,22.449,18.11,40.666,40.507,40.922 C226.779,372.73,208.699,354.514,186.303,354.257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M140.807,483.675c-22.449,0.03-40.666,18.11-40.922,40.505 C122.334,524.15,140.55,506.07,140.807,483.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M183.809,524.389c-0.031-22.449-18.11-40.666-40.507-40.922 C143.332,505.916,161.412,524.132,183.809,524.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3AAA35"
    },
    d: "M99.885,440.258c0.03,22.449,18.11,40.666,40.506,40.922 C140.36,458.73,122.28,440.514,99.885,440.258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M227.226,483.675c-22.449,0.03-40.666,18.11-40.923,40.505 C208.752,524.15,226.969,506.07,227.226,483.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91C254"
    },
    d: "M229.305,480.971c22.449-0.029,40.666-18.109,40.922-40.506 C247.777,440.496,229.561,458.576,229.305,480.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M186.303,440.258c0.031,22.449,18.11,40.666,40.507,40.922 C226.779,458.73,208.699,440.514,186.303,440.258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M140.807,569.675c-22.449,0.03-40.666,18.11-40.922,40.505 C122.334,610.15,140.55,592.07,140.807,569.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M183.809,610.389c-0.031-22.449-18.11-40.666-40.507-40.922 C143.332,591.916,161.412,610.132,183.809,610.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M99.885,526.258c0.03,22.449,18.11,40.666,40.506,40.922 C140.36,544.731,122.28,526.514,99.885,526.258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M227.226,569.675c-22.449,0.03-40.666,18.11-40.923,40.505 C208.752,610.15,226.969,592.07,227.226,569.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M270.227,610.389c-0.03-22.449-18.11-40.666-40.506-40.922 C229.751,591.916,247.83,610.132,270.227,610.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M229.305,566.971c22.449-0.029,40.666-18.109,40.922-40.506 C247.777,526.496,229.561,544.576,229.305,566.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M186.303,526.258c0.031,22.449,18.11,40.666,40.507,40.922 C226.779,544.731,208.699,526.514,186.303,526.258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M140.807,655.675c-22.449,0.03-40.666,18.11-40.922,40.505 C122.334,696.15,140.55,678.07,140.807,655.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M183.809,696.389c-0.031-22.449-18.11-40.666-40.507-40.922 C143.332,677.916,161.412,696.132,183.809,696.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M99.885,612.258c0.03,22.449,18.11,40.666,40.506,40.922 C140.36,630.731,122.28,612.514,99.885,612.258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M12.885,95.257c0.03,22.449,18.11,40.666,40.506,40.922C53.36,113.73,35.28,95.514,12.885,95.257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M53.807,224.675c-22.449,0.03-40.666,18.11-40.922,40.505 C35.334,265.15,53.55,247.07,53.807,224.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M55.886,221.971c22.449-0.03,40.666-18.11,40.923-40.506 C74.359,181.496,56.143,199.576,55.886,221.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M12.885,181.257c0.03,22.449,18.11,40.666,40.506,40.922 C53.36,199.73,35.28,181.514,12.885,181.257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M96.809,351.389c-0.031-22.449-18.11-40.666-40.507-40.922 C56.332,332.915,74.412,351.132,96.809,351.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3AAA35"
    },
    d: "M96.809,438.389c-0.031-22.449-18.11-40.666-40.507-40.922 C56.332,419.916,74.412,438.132,96.809,438.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M55.886,394.971c22.449-0.03,40.666-18.11,40.923-40.506 C74.359,354.496,56.143,372.576,55.886,394.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3AAA35"
    },
    d: "M55.886,480.971c22.449-0.029,40.666-18.109,40.923-40.506 C74.359,440.496,56.143,458.576,55.886,480.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M53.807,569.675c-22.449,0.03-40.666,18.11-40.922,40.505 C35.334,610.15,53.55,592.07,53.807,569.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91C254"
    },
    d: "M96.809,610.389c-0.031-22.449-18.11-40.666-40.507-40.922 C56.332,591.916,74.412,610.132,96.809,610.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91C254"
    },
    d: "M55.886,566.971c22.449-0.029,40.666-18.109,40.923-40.506 C74.359,526.496,56.143,544.576,55.886,566.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M12.885,526.258c0.03,22.449,18.11,40.666,40.506,40.922 C53.36,544.731,35.28,526.514,12.885,526.258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M12.885,612.258c0.03,22.449,18.11,40.666,40.506,40.922 C53.36,630.731,35.28,612.514,12.885,612.258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91C254"
    },
    d: "M270.227,696.389c-0.03-22.449-18.11-40.666-40.506-40.922 C229.751,677.916,247.83,696.132,270.227,696.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M186.303,612.258c0.031,22.449,18.11,40.666,40.507,40.922 C226.779,630.731,208.699,612.514,186.303,612.258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M616.598,783.389c-0.029-22.449-18.109-40.666-40.504-40.922 C576.123,764.916,594.203,783.131,616.598,783.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M661.886,739.971c22.449-0.029,40.666-18.109,40.923-40.506 C680.359,699.496,662.143,717.576,661.886,739.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91C254"
    },
    d: "M618.885,699.258c0.03,22.449,18.11,40.666,40.506,40.922 C659.36,717.731,641.28,699.514,618.885,699.258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M746.226,742.675c-22.449,0.03-40.666,18.11-40.923,40.505 C727.752,783.15,745.969,765.07,746.226,742.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3AAA35"
    },
    d: "M705.303,699.258c0.031,22.449,18.11,40.666,40.507,40.922 C745.779,717.731,727.699,699.514,705.303,699.258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M488.886,739.971c22.449-0.029,40.666-18.109,40.923-40.506 C507.359,699.496,489.143,717.576,488.886,739.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M445.885,699.258c0.03,22.449,18.11,40.666,40.506,40.922 C486.36,717.731,468.28,699.514,445.885,699.258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91C254"
    },
    d: "M575.305,739.971c22.449-0.029,40.666-18.109,40.922-40.506 C593.777,699.496,575.561,717.576,575.305,739.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M532.303,699.258c0.031,22.449,18.11,40.666,40.507,40.922 C572.779,717.731,554.699,699.514,532.303,699.258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M272.885,699.258c0.03,22.449,18.11,40.666,40.506,40.922 C313.36,717.731,295.28,699.514,272.885,699.258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M402.305,739.971c22.449-0.029,40.666-18.109,40.922-40.506 C420.777,699.496,402.561,717.576,402.305,739.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007C37"
    },
    d: "M55.886,739.971c22.449-0.029,40.666-18.109,40.923-40.506 C74.359,699.496,56.143,717.576,55.886,739.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91C254"
    },
    d: "M229.305,739.971c22.449-0.029,40.666-18.109,40.922-40.506 C247.777,699.496,229.561,717.576,229.305,739.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91C254"
    },
    d: "M186.303,699.258c0.031,22.449,18.11,40.666,40.507,40.922 C226.779,717.731,208.699,699.514,186.303,699.258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91C254"
    },
    d: "M489.512,567.182c22.449-0.03,40.666-18.11,40.922-40.506 C507.984,526.706,489.769,544.785,489.512,567.182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91C254"
    },
    d: "M662.885,568.258c0.03,22.449,18.11,40.666,40.506,40.922 C703.36,586.731,685.28,568.514,662.885,568.258z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundGraphics1);
export default __webpack_public_path__ + "static/media/background_graphics_1.cddf7dfd6fbc15f99f7d5ffc53f12dbd.svg";
export { ForwardRef as ReactComponent };